import { render } from "./EnrolleeEditOnboardComponent.vue?vue&type=template&id=710c6378&scoped=true"
import script from "./EnrolleeEditOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeEditOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeEditOnboardComponent.vue?vue&type=style&index=0&id=710c6378&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710c6378"]])

export default __exports__